import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import { APIErrorResponse, Quotation } from '@/types'
import { getUseQuotationDetailsKey } from './useQuotationDetails'

export const usePostQuotationSendForSignature = (
  quotationId: number
): UseMutationResult<Quotation, APIErrorResponse, void> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    () =>
      client
        .post(`/quotations/${quotationId}/send_for_signature/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: () => {
        const key = getUseQuotationDetailsKey(quotationId)

        queryClient.invalidateQueries(key)
      },
    }
  )
}
